module.exports = __webpack_public_path__ + "static/media/weixinxiao.4cff52bf.png";